import React, { useState } from 'react';
import Viewer from 'react-viewer';

const ImageModal = ({ images, visible = false, setShowImageCarousel }) => {
  const [activeIndex, setActiveIndex] = useState(undefined);

  return visible ? (
    <div className="my-modal">
      <Viewer
        visible={visible}
        rotatable={false}
        scalable={false}
        noNavbar
        drag={false}
        noImgDetails
        onMaskClick={() => setShowImageCarousel()}
        onClose={() => { setShowImageCarousel(); }}
        images={
          images.map((item) => ({
            src: item.url,
            alt: null,
          }))
        }
      />
    </div>
  ) : null;
};

export default ImageModal;
